import React, { useState, useMemo, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import { TABLE_ROWS_PER_PAGE } from "../../../utils/Constants";
import SkeletonTicketList from "../../../loaders/SkeletonTicketList";
import hasPermission from "../../../utils/hasMultiplePermission";
import Tablefilter from "../../common/Tablefilter";
import { RenderMenuItemStatus, RendermenuitemStatus, RenderMenuItemType } from "../../../utils/CommonStatusItems";
import axios from "axios";
import { handleTableScroll } from "../../../utils/commonFunction";
import $ from "jquery";
import { GetMenusItemListsFilterCancelToken, getMenusItemsList } from "../../../services/Menusserver";
import { TrimText } from "../../common/TrimText";
import DataTableComponent from "../../common/DataTableComponent";
import DataTableComponentFrontPagination from "../../common/DataTableComponentFrontPagination";

function AddMenuItems({ id, setMenuStructure, menuStructureData, setMenuStructureData, menuStructure }) {

    const history = useHistory();
    const [search, setSearch] = useState("");
    const [debouncedTerm, setDebouncedTerm] = useState("");
    const [status, setStatus] = useState({ arr: [], checkObj: {} });
    const [menuType, setMenuType] = useState({ arr: [], checkObj: {} });
    const [searchStatusCheck, setSearchStatusCheck] = useState({});
    const givenPermsisions = useSelector((state) => state.givenPermission);
    const [deleterow, setDeleteRow] = useState(false);
    const [loading, setloading] = useState(true);
    const [totalRows, setTotalRows] = useState("");
    const [perPage, setPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [sortkey, setSortKey] = useState("MenuItemAlias");
    const [sortOrder, setSortOrder] = useState("desc");
    const [filterData, setFilterData] = useState({ status: [], menuType: [] });
    const [dataSearch, setDataSearch]=useState("")
    const [TableState, setTableState] = useState({
        page: 1,
        perPage: 10,
        sortKey: "MenuItemAlias",
        sortOrder: "asc",
      });
      
    useEffect(() => {
        handleTableScroll()
    }, [loading])

    useEffect(() => {
        $(document).ready(function () {
            $(".dropdown-toggle").click(function () {
                $('.rdt_TableCell').css('z-index', 0)
                $(this).parents('.rdt_TableCell').css('z-index', 22)
            });
        });
    })

    useEffect(() => {
        const storedFilters = JSON.parse(localStorage.getItem("filterStateMenuItemListMain"));
        if (storedFilters) {
            setStatus(storedFilters.status);
            setMenuType(storedFilters.menuType);
        }
    }, []);

    useEffect(() => {
        const filterState = {
            status,
            menuType
        };
        localStorage.setItem("filterStateMenuItemListMain", JSON.stringify(filterState));
    }, [status, menuType]);

    useEffect(() => {
        $(document).ready(function () {
            $(".dropdown-toggle").click(function () {
                $('.rdt_TableCell').css('z-index', 0)
                $(this).parents('.rdt_TableCell').css('z-index', 22)
            });
        });
    })


    // get list
    useEffect(() => {
        const getMenuItemList = async () => {
            setloading(true);

            const menuItemData = {
                exportStatus: "true",
                menu_id: id,
                isAssigned: 1,
                // page: TableState.page,
                // perPage: TableState.perPage,
                // sort: TableState.sortOrder,
                // key: TableState.sortKey,
                search: dataSearch,
                viaStatus: status.arr,
                viaType: menuType.arr,
                // assign_id: menuStructure.map((item) => item.id)
            };

            try {
                const res = await getMenusItemsList(menuItemData);

                if (res.status === 200) {
                    setMenuStructureData(res?.data);
                    // setTotalRows(res.data?.total);
                    // setPerPage(res.data?.perPage);
                    setloading(false);
                } else {
                    console.error('Unexpected response status:', res.status);
                    setloading(false);
                }
            } catch (error) {
                if (!axios.isCancel(error)) {
                    // Log errors
                    console.error('Error fetching menu items:', error);
                    setloading(false);
                }
            }
        };
        getMenuItemList();
    }, [page, perPage, sortOrder, sortkey, search, status, menuType, searchStatusCheck]);

    // get dropdownlist
    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await GetMenusItemListsFilterCancelToken(id, 1);
                setFilterData({
                    status: res?.data?.menusItemStatusFilters,
                    menuType: res?.data?.menusItemTypesFilters,
                })
            } catch (error) {
                if (!axios.isCancel(error)) {
                    console.error(error);
                }
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        let response = hasPermission({
            scopes: ["sview"],
            permissions: givenPermsisions,
        });
        if (!response) {
            history.push("/noaccess");
        }
    }, [deleterow]);

    const handleSearchFilter = (e) => {
        const value = e.target.value;
        setDebouncedTerm(value);
    };

    const resetFilter = () => {
        setSearch("");
        setDebouncedTerm("");
        setStatus({ arr: [], checkObj: {} });
        setMenuType({ arr: [], checkObj: {} });
        setSearchStatusCheck({});
    };

    useEffect(() => {
        return resetFilter()
    }, [])

    const handlePageChange = (pageNo) => {
        setPage(pageNo);
    };

    const handleAdd = (row, type) => {
        if (type == 'add') {
            const newItem = {
                id: row.MenuItemID,
                title: TrimText(row.MenuItemAlias, 35),
                data: { ...row },
                className: "parent-node",
            };

            setMenuStructure(prevItems => [...prevItems, newItem]);
        }
        else if (type === 'remove') {
            const updatedMenuStructureData = menuStructure.filter(data => data.id !== row.MenuItemID);

            setMenuStructure(updatedMenuStructureData);
        }

        // const updatedMenuStructureData = menuStructureData.filter(data => data.MenuItemID !== row.MenuItemID);

        // setMenuStructureData(updatedMenuStructureData);

        // setPerPage(row)
    }


    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
    };

    const handleSort = (column, sortDirection) => {
        setSortKey(column.sortField);
        setSortOrder(sortDirection === 'asc' ? 'asc' : 'desc');
    };

    const handleRedirection = (ID) => {
        if (hasPermission({ scopes: ["sgiview"], permissions: givenPermsisions })) {
            return `/studentAdministration/students/open/${ID}/general`;
        } else if (
            hasPermission({ scopes: ["spiview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/personal`;
        } else if (
            hasPermission({ scopes: ["sedview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/education`;
        } else if (
            hasPermission({ scopes: ["sapiview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/account`;
        } else if (
            hasPermission({ scopes: ["scpview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/coursesAndProgramme`;
        } else if (
            hasPermission({ scopes: ["sasview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/assessments`;
        } else if (
            hasPermission({ scopes: ["snview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/notifications`;
        } else if (
            hasPermission({ scopes: ["scaview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/classAttendance`;
        } else if (
            hasPermission({ scopes: ["slview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/licenses`;
        } else if (
            hasPermission({ scopes: ["scview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/certificates`;
        } else if (
            hasPermission({ scopes: ["saview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/appeals`;
        } else if (
            hasPermission({ scopes: ["stview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/tickets`;
        } else if (
            hasPermission({ scopes: ["snoview"], permissions: givenPermsisions })
        ) {
            return `/studentAdministration/students/open/${ID}/notes`;
        } else {
            return `/studentAdministration/students/open/${ID}/auditTrail/employee`;
        }
        // history.push(redirectLink)
    };

    const dataToRenderArticulationAssign = () => {
        let updatedData = [];
        let allData = menuStructureData;
        if (dataSearch.length) {
            let name = allData.filter((item) => {
                let includes = item.MenuItemAlias
                    .toString()
                    .toLowerCase()
                    .includes(dataSearch.toLowerCase());
                if (includes) {
                    return includes;
                } else return null;
            });

            let data = [...name];
            let unique = [...new Set(data)];

            updatedData = unique;
        } else {
            updatedData = allData;
        }
        if (status.arr.length) {
            let tempStatus = updatedData;
            let tempResult = tempStatus.filter((item) => {
                const startsWith = status.arr.find(function (post, index) {
                    if (item.MenuItemStatus !== null && post == item.MenuItemStatus !== null ? item.MenuItemStatus.toString() : "") return item;
                });
                if (startsWith) {
                    return startsWith;
                } else return null;
            });

            updatedData = tempResult;
        }

        if (menuType.arr.length) {
            let tempProgType = updatedData;
            let tempResult = tempProgType?.filter((item) => {
                const startsWith = menuType.arr.find(function (post, index) {
                    if (item.MenuItemTypeID && post == item.MenuItemTypeID ? item.MenuItemTypeID : "") return item;
                });
                if (startsWith) {
                    return startsWith;
                } else return null;
            });
            updatedData = tempResult;
        }

        if (status.arr.length || menuType.arr.length || dataSearch.length) {
            const uniqueData = updatedData?.filter((value, index, self) =>
                index === self.findIndex((t) => (
                    t.MenuItemID == value.MenuItemID
                )))
            return uniqueData
        } else {
            const uniqueData = allData?.filter((value, index, self) =>
                index === self.findIndex((t) => (
                    t.MenuItemID == value.MenuItemID
                )))
            return uniqueData;
        }
    };


    const sortingName = (rowA, rowB) => {
        const type1 =
            rowA?.MenuItemAlias ? rowA?.MenuItemAlias?.toString() : "";
        const type2 =
            rowB?.MenuItemAlias ? rowB?.MenuItemAlias?.toString()
                : "";
        return type1.localeCompare(type2);
    };

    const sortingmenuItem = (rowA, rowB) => {
        const type1 =
            rowA?.MenuItemType ? rowA?.MenuItemType?.toString() : "";
        const type2 =
            rowB?.MenuItemType ? rowB?.MenuItemType?.toString()
                : "";
        return type1.localeCompare(type2);
    };  
    const sortingStatus = (rowA, rowB) => {
        const type1 =
            rowA?.MenuItemStatus ? rowA?.MenuItemStatus?.toString() : "";
        const type2 =
            rowB?.MenuItemStatus ? rowB?.MenuItemStatus?.toString()
                : "";
        return type1.localeCompare(type2);
    };

    const columns = useMemo(() => [
        {
            name: "Title",
            selector: "MenuItemAlias",
            sortField: "MenuItemAlias",
            sortable: true,
            sortFunction: sortingName,
            cell: (row) => (
                <div>
                    {/* <PermissionsGate scopes={["sgiview"]} RenderError={() => <p>{row.first_name + " " + row.last_name}</p>}> */}
                    <Link
                        className="as-text-blue curser feature-name"
                        // to={handleRedirection(row.id)}
                        title={row.MenuItemAlias}
                    >
                        <span>{row.MenuItemAlias}</span>
                    </Link>
                    {/* </PermissionsGate> */}
                </div>
            ),
        },
        {
            name: "Menu Item Type",
            selector: "MenuItemType",
            sortField: "MenuItemTypeID",
            sortFunction: sortingmenuItem,
            sortable: true,
            cell: (row) => (row.MenuItemType ?
                <div className="textLimit100 item-text-green" title={row.MenuItemType}>
                    {RenderMenuItemType(row?.MenuItemType).html}
                </div>
                : "-")
        },
        {
            name: "Status",
            selector: "MenuItemStatus",
            sortField: "MenuItemStatus",
            sortable: true,
            sortFunction: sortingStatus,
            sortable: true,
            // maxWidth: "120px",
            // minWidth: "120px",
            cell: (row) => RendermenuitemStatus(row?.MenuItemStatus).html,
        },
        {
            name: "Actions",
            selector: "",
            // maxWidth: "50px",
            cell: (row) => (

                <div className="assessment-08 btn-dropdown-grp">
                    <div className="as-buttons d-flex">
                        {menuStructure?.some((data) => data.id === row.MenuItemID) ? (
                            <button
                                className="btn btn-danger rounded-circle"
                                onClick={() => handleAdd(row, 'remove')}
                            >
                                <i className="fal fa-minus"></i>
                            </button>
                        ) : (
                            <button
                                className="btn btn-primary rounded-circle"
                                onClick={() => handleAdd(row, 'add')}
                            >
                                <i className="fal fa-plus"></i>
                            </button>
                        )}

                    </div>
                </div>

            ),
        },
    ]);

    useEffect(() => {
        const timer = setTimeout(() => setSearch(debouncedTerm), 1000);
        return () => {
            clearTimeout(timer);
        }
    }, [debouncedTerm])


    return (
        <div className="my-tickets-info-list Tickets-main-wrap">
            <div className="custom-table-div filter-search-icon card card-table-custom program-table border-0">
              <DataTableComponentFrontPagination
                data={dataToRenderArticulationAssign()}
                columns={columns}
                loading={loading}
                search={dataSearch}
                setSearch={setDataSearch}
                // state={TableState}
                // setState={setTableState}
                // totalRows={totalRows}
                isExport={false}
                isInsidePopUp={true}
                keyField="MenuItemID"
                // onSort={handleSort}
                filters={[
                  {
                    filterName: "Status",
                    optionArr:filterData?.status,
                    state:status ,
                    setState: setStatus,
                    stopOptionSorting:true,
                    isOptionReversed:false,
                    renderLabelFunction: RenderMenuItemStatus,
                  },
                  {
                    filterName:"Menu Item Type",
                    optionArr:filterData?.menuType,
                    state: menuType,
                    setState: setMenuType,
                    stopOptionSorting:true,
                    isOptionReversed:false,
                    renderLabelFunction: RenderMenuItemType,
                  },
                ]}
              />
            </div>
          </div>
    //     
    );
}

export default AddMenuItems;
